module.exports = __webpack_public_path__ + "static/media/NOTCLEAR.19e951fa.svg";